module.exports = __webpack_public_path__ + "img/人物_05.29897403.png";